import api from "../..";
import { uploadFile } from "../../file/uploadFile";
import type { SignRequestBody } from "../../file/types";
import type { PatchStoryBody, PatchStoryParams } from "./types";

export const patchStory = async ({ uuid, originalStory, storyFile, coverFile, description, coverText, buttonText, related_content }: PatchStoryParams): Promise<boolean> => {

  const body: PatchStoryBody = {};

  if (description !== originalStory.description) body.description = description;
  if (coverText !== originalStory.title) body.title = coverText;
  if (buttonText !== originalStory.label) body.label = buttonText;
  if (related_content !== originalStory.related_content) body.related_content = related_content;

  if (storyFile) {
    const signBody: SignRequestBody = {
      item_type: "course",
      item_id: Date.now(),
      object_name: storyFile.name,
      object_type: storyFile.type.startsWith("video") ? "video" : "image",
      object_size: storyFile.size,
    };

    body.content = await uploadFile({
      file: storyFile,
      signBody,
    });
  }

  if (coverFile) {
    const signBody: SignRequestBody = {
      item_type: "course",
      item_id: Date.now(),
      object_name: coverFile.name,
      object_type: "image",
      object_size: coverFile.size,
    };

    body.cover_image = await uploadFile({
      file: coverFile,
      signBody,
    });
  }

  return await api.patch(`/admin/story/${uuid}/`, body)
  .then(() => true)
  .catch(() => false);
};